import { render, staticRenderFns } from "./purchasingList.vue?vue&type=template&id=1b312ace&scoped=true"
import script from "./purchasingList.vue?vue&type=script&lang=js"
export * from "./purchasingList.vue?vue&type=script&lang=js"
import style0 from "./purchasingList.vue?vue&type=style&index=0&id=1b312ace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b312ace",
  null
  
)

export default component.exports